export default __webpack_public_path__ + "static/robot-humanoid-using-tablet-computer-big-data-analytic-2f51a7e6a041f1a3d6ec384039ef8ecb.png";